enum RoleType {
    Public = 1,
    Apartment = 2,
    Account = 3
}

export default RoleType;
